// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import StyledButton from '../styles/PressAbleCard.style';

const PressAbleCard = ({
  children,
  onPress,
  isCardAnimationEnabled,
  disabled,
  additionalClassName,
}) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleTouchStart = useCallback(
    (e) => {
      if (disabled) return;
      setIsPressed(true);
      e.stopPropagation();
    },
    [disabled]
  );

  const handleMouseUp = useCallback(() => setIsPressed(false), []);
  const handleTouchEnd = useCallback(() => setIsPressed(false), []);
  const handleMouseDown = useCallback(() => setIsPressed(true), []);
  const handleMouseLeave = useCallback(() => setIsPressed(false), []);

  return (
    <StyledButton
      onClick={onPress}
      isPressed={isPressed}
      disabled={disabled}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      className={`press-able-card-button ${additionalClassName}`}
      isCardAnimationEnabled={isCardAnimationEnabled}
    >
      {children}
    </StyledButton>
  );
};

PressAbleCard.propTypes = {
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  additionalClassName: PropTypes.string,
  isCardAnimationEnabled: PropTypes.bool,
};

PressAbleCard.defaultProps = {
  onPress: () => {},
  disabled: false,
  additionalClassName: '',
  isCardAnimationEnabled: false,
};

export const areEqual = (prevProps, nextProps) =>
  prevProps.onPress === nextProps.onPress &&
  prevProps.children === nextProps.children &&
  prevProps.isCardAnimationEnabled === nextProps.isCardAnimationEnabled;

export default React.memo(PressAbleCard, areEqual);
